import { call, put, takeLatest } from "redux-saga/effects"
import axios from "axios"
import {
  GET_AMBASSADOR_PROFILE_WATCHER,
  GET_DASHBOARD_WATCHER,
  GET_TASK_WATCHER,
  SUBMIT_FEEDBACK_SURVEY_WATCHER,
  DISMISS_FEEDBACK_SURVEY_WATCHER,
} from "./constants"
import {
  getProfileAmbassadorSuccess,
  getDashboardSuccess,
  getTaskSuccess,
} from "./actions"
import { LOCAL_AMBASSADOR_ID,LOCAL_COMPANY_ID, LOCAL_TOKEN } from "../../../utils/storage"

export function* getAmbassadorProfileSaga(params) {
  try {
    const { data } = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: `ambassadors/${LOCAL_AMBASSADOR_ID()}`,
      params: null,
    })
    const surveys = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: `questionnaire/employee/${data.ambassador[0].id_employee}/measure`,
      params: null,
    })

    const result = {
      plans: data.action_plans,
      ambassador: data.ambassador[0],
      divisions: data.divisions,
      filter: data.filter,
      surveys: surveys.data.data,
    }
    yield put(getProfileAmbassadorSuccess(result))
  } catch (error) {
    // returnMessage(error)
  }
}

export function* getDashboardSaga(params) {
  try {
    const { data } = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: `ambassadors/dashboard/${LOCAL_AMBASSADOR_ID()}`,
      params: null,
    })
    yield put(getDashboardSuccess(data.data.result))
  } catch (error) {
    // returnMessage(error)
  }
}

export function* getTaskSaga(params) {
  try {
    const { data } = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: `ambassadors/dashboard/${LOCAL_AMBASSADOR_ID()}`,
      params: null,
    })
    const dataProfile = yield call(fetchGlobalApi, {
      method: "GET",
      endpoint: `ambassadors/${LOCAL_AMBASSADOR_ID()}`,
      params: null,
    })
    const result = {
      dashboard: data.data.result,
      profile: {
        plans: dataProfile.data.action_plans,
        ambassador: dataProfile.data.ambassador[0],
        divisions: dataProfile.data.divisions,
        filter: dataProfile.data.filter,
      },
    }
    yield put(getTaskSuccess(result))
  } catch (error) {
    // returnMessage(error)
  }
}
function submitFeedbackSurveyApi(params) {
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}feedback-survey/`,
    data: {
      id_company: Number(LOCAL_COMPANY_ID()),
      score: params.score,
      comments: params.comments
    }
  })
}
function dismissFeedbackSurveyApi(){
  return axios.request({
    method: "post",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}feedback-survey/dismiss`,
  })
}
export function* submitFeedbackSurveySaga(params) {
  try {
    yield call(submitFeedbackSurveyApi, params.payload)
  } catch (e) { }
}
export function* dismissFeedbackSurveySaga(params) {
  try {
    yield call(dismissFeedbackSurveyApi)
  } catch (e) { }
}
// Individual exports for testing
export default function* getAdministratorWatcherSaga() {
  yield takeLatest(GET_AMBASSADOR_PROFILE_WATCHER, getAmbassadorProfileSaga)
  yield takeLatest(GET_DASHBOARD_WATCHER, getDashboardSaga)
  yield takeLatest(GET_TASK_WATCHER, getTaskSaga)
  yield takeLatest(SUBMIT_FEEDBACK_SURVEY_WATCHER, submitFeedbackSurveySaga)
  yield takeLatest(DISMISS_FEEDBACK_SURVEY_WATCHER, dismissFeedbackSurveySaga)
}
